import { connectRoutes } from 'redux-first-router'
import createHistory from 'history/createBrowserHistory'
import qs from 'qs'
// import queryString from 'query-string'

import routesMap from '@/state/routesMap'
import callbacks from '@/state/callbacks'

const history = createHistory()

const { reducer, middleware, enhancer, initialDispatch } = connectRoutes(history, routesMap, {
  querySerializer: qs,
  ...callbacks,
})
// const { reducer, middleware, enhancer } = connectRoutes(history, routesMap, callbacks)

// @HACK Exporting when assigning the variables above works when the application compiles to run,
// however Jest chokes on the reducer when running our snapshot tests.
export { reducer, middleware, enhancer, initialDispatch, routesMap }



// WEBPACK FOOTER //
// ./state/routes.js